import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks the shift-request action on the dashboard
 * Event: dental_portal:dashboard:shift_request_clicked
 */
export function fireDashboardShiftRequestClicked(): void {
  PosthogService.getInstance().track('dental_portal:dashboard:shift_request_clicked');
}
